export class PermiteUsuarioSemCpfDto {
  permiteUsuarioSemCpf: boolean;

  constructor(permiteUsuarioSemCpf: boolean) {
    this.permiteUsuarioSemCpf = permiteUsuarioSemCpf;
     }
}
